import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesTasksGetAsyncSlice } from './get';
import { coreInitiativesTasksPostAsyncSlice } from './post';
import { coreInitiativesTasksByIdReducers, coreInitiativesTasksByIdWatchers } from './_id';
import { coreInitiativesTasksLinkReducers, coreInitiativesTasksLinkWatchers } from './link';
import { coreInitiativesTasksOrderReducers, coreInitiativesTasksOrderWatchers } from './order';

export const coreInitiativesTasksReducers = combineReducers({
	byId: coreInitiativesTasksByIdReducers,
	get: coreInitiativesTasksGetAsyncSlice.asyncReducers,
	link: coreInitiativesTasksLinkReducers,
	order: coreInitiativesTasksOrderReducers,
	post: coreInitiativesTasksPostAsyncSlice.asyncReducers
});

export const coreInitiativesTasksWatchers = combineAllWatchers([
	coreInitiativesTasksByIdWatchers,
	coreInitiativesTasksGetAsyncSlice.asyncWatchers,
	coreInitiativesTasksLinkWatchers,
	coreInitiativesTasksOrderWatchers,
	coreInitiativesTasksPostAsyncSlice.asyncWatchers
]);
